'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TeamDetailController = function () {
    function TeamDetailController(ApiTeam, ApiUser, $ionicLoading, $ionicPopup, $scope, $state, ApiSelections, MessageBox, $filter, $rootScope, $timeout) {
        _classCallCheck(this, TeamDetailController);

        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$scope = $scope;
        this.$state = $state;
        this.ApiTeam = ApiTeam;
        this.ApiUser = ApiUser;
        this.MessageBox = MessageBox;
        this.isGroupAdmin = false;
        this.data = null; // encapsulated object
        this.members = null; // members of the currently selected team
        this.teamLoaded = false; // flag to indicate that team data has been fetched
        this.membersLoaded = false; // flag to indicate that member data has been fetched
        this.email = ''; // email to add members to the team
        this.user = {};
        this.ApiSelections = ApiSelections;
        this.$filter = $filter;
        this.addTeamMemberInputModal = null;
        this.$timeout = $timeout;

        var self = this;
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParam) {
            if (self.addTeamMemberInputModal != null) self.addTeamMemberInputModal.close();
        });
    }

    _createClass(TeamDetailController, [{
        key: 'showLoading',
        value: function showLoading() {
            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });
        }
    }, {
        key: 'init',
        value: function init() {
            var _this = this;

            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });

            this.ApiTeam.getTeams().then(function (res) {
                if (typeof res != 'undefined') {
                    if (res) {
                        _this.data = res || {};
                        _this.teamLoaded = true;

                        var teamPromises = [];
                        var teamMemberPromise = _this.ApiTeam.getTeamMembers().then(function (res) {
                            if (res != undefined) {
                                _this.members = res.length > 0 ? res : null;
                                _this.membersLoaded = true;
                            }
                        });
                        teamPromises.push(teamMemberPromise);

                        var isGroupAdminPromise = _this.ApiTeam.isGroupAdmin().then(function (res) {
                            if (typeof res != 'undefined') {
                                _this.isGroupAdmin = res;
                            }
                        });
                        teamPromises.push(isGroupAdminPromise);

                        var getUserPromise = _this.ApiUser.getUser().then(function (res) {
                            if (typeof res != 'undefined') {
                                _this.user = res;
                            }
                        });
                        teamPromises.push(getUserPromise);

                        var teamSelectionsPromise = _this.getTeamPackages();
                        teamPromises.push(teamSelectionsPromise);

                        Promise.all(teamPromises).then(function (res) {
                            _this.$ionicLoading.hide();
                        });
                    } else {
                        _this.teamLoaded = false;
                        _this.$ionicLoading.hide();
                    }
                }
            });
        }
    }, {
        key: 'onPopupLoad',
        value: function onPopupLoad() {
            this.teamMemberAdded = false;
            this.$timeout(function () {
                angular.element(document.querySelector('#emailTxt'))[0].focus();
            }, 200);
        }
    }, {
        key: 'addTeamMember',
        value: function addTeamMember() {
            var _this2 = this;

            var dialogResult = this.$ionicPopup.show({
                template: '<form name="popupForm" novalidate>' + '<input type="email" id="emailTxt" ng-model="team.email" ng-pattern="/^[_a-z0-9]+(.[_a-z0-9]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,4})$/" required ng-init="team.onPopupLoad()">' + '<p class="error" ng-if="popupForm.$invalid && team.teamMemberAdded">Please enter a valid email address</p>' + '</form>',
                title: 'Add Team Member',
                subTitle: 'Enter the email address of the user you want to add to this team.',
                scope: this.$scope,
                buttons: [{
                    text: 'Cancel'
                }, {
                    text: '<b>Add</b>',
                    type: 'button-picton-blue',
                    onTap: function onTap(e) {
                        this.scope.$parent.team.teamMemberAdded = true;
                        if (!this.scope.$parent.team.email) {
                            //don't allow the user to close unless he enters the email
                            e.preventDefault();
                        } else {
                            var form = this.scope.popupForm;
                            return this.scope.$parent.team.email;
                        }
                    }
                }]
            });

            this.addTeamMemberInputModal = dialogResult;

            dialogResult.then(function (email) {
                _this2.email = ''; // reset the email in the popup
                if (email) {
                    _this2.$ionicLoading.show({
                        template: '<spinner-advinda></spinner-advinda>'
                    });
                    _this2.ApiTeam.addTeamMember(email).then(function (result) {
                        if (!angular.isUndefined(result)) {
                            var promiseArray = [];
                            var teamPromise = _this2.ApiTeam.getTeamMembers().then(function (res) {
                                _this2.members = res.length > 0 ? res : null;
                                _this2.membersLoaded = true;
                                _this2.MessageBox.showSuccessMessage('TEAM_MEMBER', 'ADD');
                            });
                            promiseArray.push(teamPromise);

                            var selectionPromise = _this2.getTeamPackages();
                            promiseArray.push(selectionPromise);
                            Promise.all(promiseArray).then(function (res) {
                                _this2.$ionicLoading.hide();
                            });
                        } else {
                            _this2.$ionicLoading.hide();
                        }
                    });
                }
            });
        }
    }, {
        key: 'removeTeamMember',
        value: function removeTeamMember(email, user) {
            this.leaveTeam(email, user);
        }
    }, {
        key: 'leaveTeam',
        value: function leaveTeam(email, user) {
            var _this3 = this;

            this.showLoading();
            this.ApiTeam.removeTeamMember(email).then(function (result) {
                if (user && result) {
                    _this3.members.splice(_this3.members.indexOf(user), 1);
                    var teamPackage = _this3.getTeamPackages();
                    Promise.all([teamPackage]).then(function () {
                        _this3.$ionicLoading.hide();
                    });
                } else {
                    _this3.$state.go(_this3.$state.$current, null, { reload: true });
                }
            });
        }
    }, {
        key: 'deleteTeam',
        value: function deleteTeam() {
            var _this4 = this;

            this.showLoading();
            this.ApiTeam.deleteTeam(this.data).then(function (res) {
                _this4.teamLoaded = false;
                _this4.membersLoaded = false;
                _this4.data = null;
                _this4.isGroupAdmin = false;
                _this4.members = null;
                _this4.$ionicLoading.hide();
                _this4.$state.go('teamDetail');
                _this4.MessageBox.showSuccessMessage('TEAM', 'DELETE');
            }, function (error) {
                this.$ionicLoading.hide();
                this.MessageBox.showFailMessage('TEAM', 'DELETE');
            });
        }
    }, {
        key: 'getTeamPackages',
        value: function getTeamPackages() {
            var _this5 = this;

            return this.ApiSelections.getPurchasedTeamSelections().then(function (res) {
                if (typeof res != 'undefined') {
                    _this5.companyPackage = res;
                }
            });
        }
    }, {
        key: 'toggleFreezeUser',
        value: function toggleFreezeUser(user) {
            this.ApiUser.toggleFreezeUser(user.id);
            user.frozen = !user.frozen;
        }
    }, {
        key: 'updateShowTranslation',
        value: function updateShowTranslation() {
            var _this6 = this;

            this.showLoading();
            this.ApiTeam.putTeam(this.data).then(function (res) {

                _this6.$ionicLoading.hide();
            }, function (error) {
                this.$ionicLoading.hide();
            });
        }
    }, {
        key: 'popUp',
        value: function popUp($event) {
            var _this7 = this;

            $event.preventDefault();
            var dialogResult = this.$ionicPopup.confirm({
                title: this.$filter('translate')('DELETE_TEAM'),
                template: this.$filter('translate')('DELETE_TEAM_PROMPT')
            });

            dialogResult.then(function (res) {
                if (res) {
                    _this7.deleteTeam();
                }
            });
        }
    }]);

    return TeamDetailController;
}();

exports.default = TeamDetailController;


TeamDetailController.inject = ['ApiTeam', 'ApiUser', '$ionicLoading', '$ionicPopup', '$scope', '$state', 'ApiSelections'];


/** WEBPACK FOOTER **
 ** ./src/app/components/team/teamDetail.controller.js
 **/